import React, { useEffect, useState } from "react"
import { imageurl, imgCheck, setToStore } from "../Utils/fn";
import { Button, CircularProgress, IconButton } from "@mui/material";
import img from "./../../assets/product-placeholder.png"
import { capitalizeFirst, currencyseperator } from "../Utils/functions";
import { useDispatch, useSelector } from "react-redux";
import { removeCartItem, updateCartItem } from "../../store/cartItems";
import { setAlert } from "../../store/alert";
import { AddBox, IndeterminateCheckBox } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";



const Cartitem = ({ product }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [thumbnail, setThumbnail] = useState(null);
    const webSettings = useSelector((state) => state.webSettings.data);
    const cartItems = useSelector(state => state.cartItems.data);
    const [updating, setUpdating] = useState(false);
    const [removing, setRemoving] = useState(false);

    useEffect(() => {
        Array.isArray(product.src) && imgCheck(imageurl(product.src[0]), img).then((src) => setThumbnail(src));
    }, [product]);

    useEffect(() => {
        setToStore('cart-items', cartItems);
    }, [cartItems]);

    function removeFromCart() {
        setRemoving(true);
        dispatch(removeCartItem(product.item_code));
        setRemoving(false);
        dispatch(setAlert({ type: 'warning', message: 'Item removed from Cart' }));
    }

    function updater(quantity) {
        if (product.closing >= quantity) {
            if (removing || updating || quantity === product.quantity) {
                // we will alert something here for the user
                return;
            }
            setUpdating(true);
            console.log(quantity)
            dispatch(updateCartItem({ ...product, quantity }));
            setUpdating(false);
        } else {
            dispatch(setAlert({ type: 'error', message: 'Item Out of stock' }));
        }
    }

    const productprice = product?.promotion_price > 0 ? product.promotion_price : product.price


    function viewProduct() {
        navigate('/product/' + product.itemURL, {
            state: { product: product }
        });
    }


    return (
        <div className='pagemini'>
            <div className="cartcard" onClick={viewProduct}>
                <div className="wrapcartimage">
                    <img src={thumbnail} />
                    {thumbnail == null && <CircularProgress />}
                </div>
                <div className="wrapcartdiv">
                    <div className="productname">{capitalizeFirst(product.item_name)}</div>
                    <div className='wrapprice' >
                        <div className='currencytext'>{webSettings.CURRENCY}</div>
                        {product.promotion_price > 0 ?
                            <div className='pricetext'>{currencyseperator(product.promotion_price)} </div> :
                            <div className='pricetext'>{currencyseperator(parseFloat(product.price)?.toFixed(2))}</div>}
                    </div>
                    <div className='unitslefttext' style={{ color: getcolor(product.closing).color, textDecorationLine: product.closing == 0 && "line-through" }}>{getcolor(product.closing).text}</div>
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button onClick={() => removeFromCart()}>Remove </Button>
                <div className="quantitybuttons" >
                    <IconButton color="primary" disabled={product.quantity == 1 && true} onClick={() => updater(product.quantity > 1 ? product.quantity - 1 : 1)}>
                        <IndeterminateCheckBox fontSize="large" />
                    </IconButton>
                    <div style={{ fontWeight: "bold" }}>{product.quantity}</div>
                    <IconButton color="primary" onClick={() => updater(product.quantity + 1)}>
                        <AddBox fontSize="large" />
                    </IconButton>
                </div>
            </div>
        </div>
    )
}
const getcolor = (number) => {
    if (number == 0) {
        return {
            color: "silver",
            text: "Out of stock"
        }
    }
    else if (number > 0 && number <= 10) {
        return {
            color: "red",
            text: `${number} units left`
        }
    }
    else if (number > 10 && number <= 40) {
        return {
            color: "orange",
            text: `Item in Stock`
        }
    }
    else if (number > 40) {
        return {
            color: "green",
            text: `Item in Stock`
        }
    } else {
        return {
            color: "red",
            text: `out of stock`
        }
    }

}
export default Cartitem